import { handleRequest } from "../utilities/requestHandler";

// Pagination is OPT-IN: called with no arguments this returns the full list,
// which is what the dropdown/filter/analytics callers across the app expect.
// Pass a params object and the server returns { rows, row_count, ... } instead.
export const getAllCustomerSites = (options) => {
    if (!options) return handleRequest("get", "/cus_sites/getsites");
    const { page = 0, pageSize = 10, search = "", sortField, sortOrder } = options;
    const params = new URLSearchParams({ page, pageSize });
    if (search) params.set("search", search);
    if (sortField) params.set("sortField", sortField);
    if (sortOrder) params.set("sortOrder", sortOrder);
    return handleRequest("get", `/cus_sites/getsites?${params.toString()}`);
};

export const updateSite = (siteId, siteData) =>
    handleRequest("put", `/cus_sites/sites/${siteId}`, siteData);

export const createSite = (siteData) =>
    handleRequest("post", "/cus_sites/sites/create", siteData);

export const deleteSites = (ids) =>
    handleRequest("post", "/cus_sites/sites/delete", { ids });

export const downloadSiteTemplate = () =>
    handleRequest("get", "/cus_sites/sites/template", null, {}, "blob");

export const bulkUploadSites = (formData) =>
    handleRequest("post", "/cus_sites/sites/bulk-upload", formData, { 'Content-Type': 'multipart/form-data' });